/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {cancelExportInternal} from '../api'

export const useMutationCancelExportInternal = createReactQueryMutationHook('cancelExportInternal', cancelExportInternal)
